module.exports = __webpack_public_path__ + "img/french_window.3c07106.svg";